import React, { useState } from 'react';
import { CardBody, Card, Container } from 'reactstrap';
// import './TataskyStyle.css'
import chatPerson from "../images/img/chat-person.png";

function Login() {
    const [loginScreen1, setLoginScreen1] = useState(true);
    const [subscriberID, setSubscriberID] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRadio, setPasswordRadio] = useState("password");
    const [registeration,setRegisteration]  =useState(false)

    const handleRadioButton = (e) => {
        const value = e.target.value;
        // console.log("setPasswordRadio",value);
        setPasswordRadio(value);
    }

    return (
        <>
            <div className=" section1">
                <div className="chat-wrapp flex-between">
                <div className="chat-person">
                                <img src={chatPerson} alt="" /> </div>
                    <div className="chat-text chatcont1_0 chatcont"> Please login to know about your pack details </div>
                    <div className="chatcont1_0 chatcont login-chatContr" >
                        <div className="card mB20" >
                            <div className="card-body" >
                                <h2 >Login to manage your Tata Sky account</h2>
                               { !registeration ?  <div id="regdrmn">
                                    <div className="form-group">
                                        <label className="sel fs14">Subscriber ID/ Registered Mobile Number</label>
                                        <input type="text" className="form-control" placeholder="" tabIndex="1" />
                                        <span className="validate">&nbsp;</span> </div>
                                    <div className="footer-contr text-center block mT20 loginbtn">
                                         <a className="btn btn-primary waves-effect waves-light action-tab rmnBtn loginbtninner" href="#" onClick={()=>{setRegisteration(true)}} style={{fontSize:'12px'}}> Continue </a> </div>
                                    <p className="mT5 text-center mB0 fs12 loginbtnp">Not Registered yet? <a href="#">Click here</a></p>
                                </div>:
                                <div id="pwotp">
                                    <div className="radio-button password-otp">
                                     
                                        <div className="rdo new-custom">
                                            <input className="form-check-input"  type="radio" name="password-otp" value="password" id="radio12" checked={passwordRadio==="password"} onChange={(e) => handleRadioButton(e)}/>
                                            <label className="form-check-label"  for="radio12"  > 
                                            <span className="month-label d-block tooltipblk otp" >Password</span> </label>
                                        </div>

                                        <div className="rdo new-custom">
                                            <input className="form-check-input"  type="radio" name="password-otp" value="otp" id="radio13" checked={passwordRadio==="otp"} onChange={(e) => handleRadioButton(e)}/>
                                            <label className="form-check-label"  for="radio13"  > 
                                            <span className="month-label d-block tooltipblk otp" >OTP</span> </label>
                                        </div>
                                    </div>
                                    {
                             passwordRadio === "password" ?   <div className="con-query-wrapp contr1" style={{display: "block"}}>
                                                        <div className="form-group">
                                        <label className="sel fs14 lbl">Enter Password</label>
                                        <input type="text" className="form-control" placeholder="" tabIndex="1" />
                                        <span className="validate">&nbsp;</span> </div>
                                    </div> :
                                    <div className="con-query-wrapp contr2" style={{display:"block"}}>
                                                        <div className="form-group">
                                        <label className="sel fs14 lbl">Enter OTP</label>
                                        <input type="text" className="form-control" placeholder="" tabIndex="1" />
                                        <span className="validate">&nbsp;</span> </div>
                                    </div>}
                                  <a href="#" class="field-info">Forgot Password?</a> 
                                    <div className="footer-contr text-center block mT15"><a className="btn btn-primary waves-effect waves-light action-tab loginbtninner" href="#" data-section-to-view="packs-channels-option"  style={{fontSize:'12px'}}> Continue </a> </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>














    );
}

export default Login;


















{/* <Container style={{padding:"0px", width:"auto"}}>
<Card classNameName="login-chat" style={{minHeight:"270px"}}>
    <CardBody>
        <h2> Login to manage your Tata Sky account</h2>
      
            { loginScreen1
            ?
            <>
                {/* Enter subscriber id/ mobile number */}
            //     <div>
            //         <label>Subscriber ID/ Registered Mobile Number</label>
            //         <input type="text" classNameName="form-control" 
            //                 onChange={(e) => {setSubscriberID(e.target.value);}}></input>
            //     </div>
            //     <div classNameName="login-chat-footer">
            //         <a href="#!"><button onClick={() => {setLoginScreen1(false); console.log("subscriberId: ",subscriberID)}}>Continue</button></a>
            //     </div>
            //     <p classNameName="login-chat-footer-text">Not Registered yet? <a href="#!">Click here</a></p>
            // </>
            // :
            // <>
                {/* Enter password */}
//                 <div>
//                     <div classNameName="login-chat-password-otp">
//                         <div>
//                             <input classNameName="form-check-input" type="radio" name="password-otp" value="password" checked={passwordRadio==="password"} onChange={(e) => handleRadioButton(e)}/>
//                             <label classNameName="form-check-label">Password</label>
//                         </div>
//                         <div>
//                             <input classNameName="form-check-input" type="radio" name="password-otp" value="otp" checked={passwordRadio==="otp"} onChange={(e) => handleRadioButton(e)}/>
//                             <label classNameName="form-check-label">OTP</label>
//                         </div>
//                     </div>

//                     <div >
//                         {
//                             passwordRadio === "password"
//                             ?
//                             <label>Enter Password</label>
//                             :
//                             <label>Enter OTP sent on {subscriberID}</label>
//                         }
//                         <input type="text" classNameName="form-control" 
//                                 onChange={(e) => {setPassword(e.target.value);}}></input>
//                         <a href="#!" className="login-chat-forgot-password">Forgot Password?</a>
//                     </div>

//                     <div classNameName="login-chat-footer">
//                         <a href="#!"><button onClick={() => {console.log("password: ",password)}}>Continue</button></a>
//                     </div>
//                 </div>
//             </>
        
//             }
//     </CardBody>
// </Card>
// </Container> */}